import React from 'react';

interface LoaderProps {
  className?: string;
  spinnerClass?: string;
  spinnerInnerClass?: string;
  icon?: string;
}
const Loader: React.FC<LoaderProps> = ({
  className,
  spinnerClass,
  spinnerInnerClass,
  icon = '/icons/spinner-inner.png',
}) => {
  return (
    <div className={`minthr-loading-wraper ${className}`}>
      <img
        className={`minthr-loading-spinner minthr-icon-xl ${spinnerClass}`}
        src="/icons/spinner-outer.svg"
        alt="spinner"
      />
      <img
        className={`minthr-loading-spinner-inner minthr-icon-s ${spinnerInnerClass}`}
        src={icon}
        alt="spinner"
      />
    </div>
  );
};

export default Loader;
